import React from "react";
import SignupBusiness from "../screens/Account/SignupBusiness";
import Layout from "../layouts/GeneralLayout";
const MobileSignupBusinessPage = () => (
  <Layout>
    <SignupBusiness />
  </Layout>
);
export default MobileSignupBusinessPage;
